import {useTranslation} from 'react-i18next';
import useConsultantsDict from '../../../hooks/useConsultantsDict';
import React, {useEffect, useState} from 'react';
import API from '../../../app/api';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import AgyleDictionaryField from '../../../components/ui/selector/agyleDictionaryField';
import {getConsultantName} from './clinitianUtils';
import AgyleDatePicker from '../../../components/ui/fields/agyleDatePicker';
import moment from 'moment/moment';
import {calculateArrivalDate} from '../../../util/patientUtil';
import {getConfig} from '../../../util/configUtil';
import ControlConsultantComponent from './controlConsultantComponent';

export function DialogSeenAndWhenExt(props) {
    const {t} = useTranslation();
    const controller = new AbortController();
    const [consultantsDict, user] = useConsultantsDict(props.allowedConsultants);

    // Dictionaries for Ambulance Handover, Nurses nad Clinicians
    const [dictAmbulanceHO, setDictAmbulanceHO] = useState([]);

    // Configs
    const defaultDateTimeFormat = getConfig('defaultDateTimeFormat');
    const consultantComponentEnabled = getConfig('consultantComponentEnabled', false);    

    useEffect(() => {
        if (props.admittedDate) {
            loadDict();
        }
    }, []);

    const loadDict = async () => {
        const medicalsStaff = [];

        const allowedConsultants = props.allowedConsultants;
        let newFilter = 'deactivated ne true and availableIn ne null';

        if (consultantComponentEnabled) {
            await API.getDictByURL(
                `/consultants?$filter=${encodeURIComponent(newFilter)}`,
                controller.signal,
            ).then((dictData) => {
                if (dictData) {
                    for (let clinician of dictData.__data) {
                        if (allowedConsultants) {
                            if (clinician.availableIn.includes(allowedConsultants)) {
                                medicalsStaff.push({
                                    ...clinician,
                                    group: 'Consultants',
                                });
                                break;
                            }
                        }
                    }
                }
            });    
        } else {
            await API.getDictByURL(`/$dict/Clinicians?$filter=${encodeURIComponent('(forAmbulance eq true and deactivated ne true)')}&$sort=description`).then((dictData) => {
                if (!_.isEmpty(dictData?.__data)) {
                    _.forEach(dictData?.__data, (element) => {
                        medicalsStaff.push({
                            ...element, group: 'Clinicians',
                        });
                    });
                }
            });

            if (props.nurse) {
                await API.getDictByURL(`/$dict/Nurses?$filter=${encodeURIComponent('(forAmbulance eq true and deactivated ne true)')}&$sort=description`).then((dictData) => {
                    if (!_.isEmpty(dictData?.__data)) {
                        _.forEach(dictData?.__data, (element) => {
                            medicalsStaff.push({
                                ...element, group: 'Nurses',
                            });
                        });
                    }
                });    
            }            
        }
        setDictAmbulanceHO([...medicalsStaff]);
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={props.horizontal ? 12 : 6}>
                {!props.nurse && !props.admittedDate &&
                    <ControlConsultantComponent
                        error={props.fromTimestamp ? false : ((props.error && !props.value?.who) || !props.value?.who)}
                        agyleRefresh
                        size={props.size}
                        allowedConsultants={props.allowedConsultants}
                        label={props.label}
                        value={props.value ? props.value?.who : props.patient.currentClinician}
                        groupBy={(opt) => props.cliniciansWithNurses ? opt.group : ''}
                        cliniciansWithNurses={props.cliniciansWithNurses}
                        onChange={(value) => {
                            props.onChange({
                                who: value, when: props.value ? props.value?.when : null,
                            });
                        }}
                        refresh={props.refresh}
                        findUser={props.findUser}
                    />
                }

                {props.nurse && !props.admittedDate &&
                    <ControlConsultantComponent
                        typeDict={'Nurses'}
                        agyleRefresh
                        error={props.fromTimestamp ? false : ((props.error && !props.value?.who) || !props.value?.who)}
                        size={props.size}
                        label={props.label}
                        value={props.value ? props.value?.who : props.patient.currentClinician}
                        groupBy={(opt) => props.cliniciansWithNurses ? opt.group : ''}
                        cliniciansWithNurses={props.cliniciansWithNurses}
                        onChange={(value) => {
                            props.onChange({
                                who: value, when: props.value ? props.value?.when : null,
                            });
                        }}
                        refresh={props.refresh}
                        findUser={props.findUser}
                    />
                }

                {props.admittedDate &&
                    <AgyleDictionaryField
                        label={t('Clinician')}
                        //getOptionLabel={(option) => option?.who?.__description ? option?.who?.__description : option?.__description}
                        getOptionLabel={(option) =>
                            option?.who ?
                                getConsultantName(option?.who) :
                                getConsultantName(option)
                        }
                        options={consultantComponentEnabled ? consultantsDict : dictAmbulanceHO}
                        groupBy={(opt) => opt.group}
                        value={props.value ? props.value?.who : props.patient.currentClinician}
                        isOptionEqualToValue={(option, value) => option.__id === value?.__id}
                        onChange={(event, newValue) => props.onChange({
                            who: newValue, when: props.value ? props.value?.when : null,
                        })}
                        error={Boolean((props.error && !props.value?.who) || !props.value?.who)}
                        noBorder={!props.refresh}
                        withNewBackground={props.refresh}
                        size={props.refresh ? 'large' : 'small'}
                    />
                }
            </Grid>

            <Grid item xs={props.horizontal ? 12 : 6}>
                <AgyleDatePicker
                    type={'dateTime'}
                    label={t('Date and Time')}
                    disabled={props.disableDateManipulation}
                    inputFormat={defaultDateTimeFormat}
                    inputVariant="outlined"
                    error={(props.error && !props.value?.when) || !props.value?.when}
                    value={props.value ? props.value?.when : null}
                    minDate={props.admittedDate ? moment(props.patient?.admission?.startDate) : moment(calculateArrivalDate(props.patient))}
                    maxDate={moment()}
                    onError={props.onError}
                    onChange={(value) => {
                        props.onChange({
                            who: props.value ? props.value?.who : null, when: moment(value).toISOString(),
                        });
                    }}
                    noBorder={!props.refresh}
                    withNewBackground={props.refresh}
                    size={props.refresh ? 'large' : 'small'}
                />
            </Grid>
        </Grid>
    );
}